"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLocalizedRegions = fetchLocalizedRegions;
exports.fetchLocalizedCountries = fetchLocalizedCountries;
exports.fetchListing = fetchListing;
exports.shouldFetchListing = shouldFetchListing;
exports.fetchListingIfNeeded = fetchListingIfNeeded;
exports.queryBuilder = queryBuilder;
exports.connectWithLoyaltyNumber = connectWithLoyaltyNumber;
exports.toggleNeedAnAccountClicked = toggleNeedAnAccountClicked;
exports.checkForConnection = checkForConnection;
exports.connectListing = connectListing;
exports.disconnectListing = disconnectListing;
exports.updateLoyaltyNum = updateLoyaltyNum;
exports.inquireListing = inquireListing;
exports.default = listing;
exports.initialState = exports.disconnectFromListing = exports.toggleModal = exports.setListings = exports.fetchListItems = exports.CONFIRMATION_MODAL = exports.DISCONNECT_MODAL = exports.UNENROLL_MODAL = exports.ENROLL_MODAL = exports.POPUP_IS_CLOSED = exports.POPUP_IS_OPEN = exports.TOGGLE_NEED_AN_ACCOUNT_CLICKED = exports.UPDATE_CONNECTION_PENDING = exports.SET_IS_CONNECTING_TO_FALSE = exports.CONNECTION_STATUS_CHECKED_SUCCESS = exports.CONNECTION_STATUS_CHECKING = exports.TOGGLE_MODAL = exports.UPDATE_LOYALTY_NUM = exports.COUNTRIES_FETCH_FAILED = exports.REGIONS_FETCH_FAILED = exports.COUNTRIES_FETCHED = exports.REGIONS_FETCHED = exports.COUNTRIES_FETCHING = exports.REGIONS_FETCHING = exports.INQUIRE_LISTING = exports.DISCONNECT_LISTING = exports.UNENROLL_LISTING = exports.CONNECT_LISTING = exports.SET_LISTINGS = exports.LISTING_SHOULD_FETCH = exports.LISTING_FETCH_FAILED = exports.LISTING_NOT_FOUND = exports.LISTING_FETCHED = exports.LISTING_FETCHING = exports.LISTING_INVALID = void 0;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _merge13 = _interopRequireDefault(require("lodash/merge"));

var _reduce2 = _interopRequireDefault(require("lodash/reduce"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _keys2 = _interopRequireDefault(require("lodash/keys"));

var _has2 = _interopRequireDefault(require("lodash/has"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _config = _interopRequireDefault(require("../config"));

var _utils = require("../utils");

var _listingsModule = require("../listings/listingsModule");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var APIEndpoint = (0, _utils.getAPIEndpoint)(); // Constants

var LISTING_INVALID = '@@listingModule/LISTING_INVALID';
exports.LISTING_INVALID = LISTING_INVALID;
var LISTING_FETCHING = '@@listingModule/LISTING_FETCHING';
exports.LISTING_FETCHING = LISTING_FETCHING;
var LISTING_FETCHED = '@@listingModule/LISTING_FETCHED';
exports.LISTING_FETCHED = LISTING_FETCHED;
var LISTING_NOT_FOUND = '@@listingModule/LISTING_NOT_FOUND';
exports.LISTING_NOT_FOUND = LISTING_NOT_FOUND;
var LISTING_FETCH_FAILED = '@@listingModule/LISTING_FETCH_FAILED';
exports.LISTING_FETCH_FAILED = LISTING_FETCH_FAILED;
var LISTING_SHOULD_FETCH = '@@listingModule/LISTING_SHOULD_FETCH';
exports.LISTING_SHOULD_FETCH = LISTING_SHOULD_FETCH;
var SET_LISTINGS = '@@listingModule/SET_LISTINGS';
exports.SET_LISTINGS = SET_LISTINGS;
var CONNECT_LISTING = '@@listingModule/CONNECT_LISTING';
exports.CONNECT_LISTING = CONNECT_LISTING;
var UNENROLL_LISTING = '@@listingModule/UNENROLL_LISTING';
exports.UNENROLL_LISTING = UNENROLL_LISTING;
var DISCONNECT_LISTING = '@@listingModule/DISCONNECT_LISTING';
exports.DISCONNECT_LISTING = DISCONNECT_LISTING;
var INQUIRE_LISTING = '@@listingModule/INQUIRE_LISTING';
exports.INQUIRE_LISTING = INQUIRE_LISTING;
var REGIONS_FETCHING = '@@listingModule/REGIONS_FETCHING';
exports.REGIONS_FETCHING = REGIONS_FETCHING;
var COUNTRIES_FETCHING = '@@listingModule/COUNTRIES_FETCHING';
exports.COUNTRIES_FETCHING = COUNTRIES_FETCHING;
var REGIONS_FETCHED = '@@listingModule/REGIONS_FETCHED';
exports.REGIONS_FETCHED = REGIONS_FETCHED;
var COUNTRIES_FETCHED = '@@listingModule/COUNTRIES_FETCHED';
exports.COUNTRIES_FETCHED = COUNTRIES_FETCHED;
var REGIONS_FETCH_FAILED = '@@listingModule/REGIONS_FETCH_FAILED';
exports.REGIONS_FETCH_FAILED = REGIONS_FETCH_FAILED;
var COUNTRIES_FETCH_FAILED = '@@listingModule/COUNTRIES_FETCH_FAILED';
exports.COUNTRIES_FETCH_FAILED = COUNTRIES_FETCH_FAILED;
var UPDATE_LOYALTY_NUM = '@@listingModule/UPDATE_LOYALTY_NUM';
exports.UPDATE_LOYALTY_NUM = UPDATE_LOYALTY_NUM;
var TOGGLE_MODAL = '@@listingModule/TOGGLE_MODAL';
exports.TOGGLE_MODAL = TOGGLE_MODAL;
var CONNECTION_STATUS_CHECKING = '@@listingModule/CONNECTION_STATUS_CHECKING';
exports.CONNECTION_STATUS_CHECKING = CONNECTION_STATUS_CHECKING;
var CONNECTION_STATUS_CHECKED_SUCCESS = '@@listingModule/CONNECTION_STATUS_CHECKED_SUCCESS';
exports.CONNECTION_STATUS_CHECKED_SUCCESS = CONNECTION_STATUS_CHECKED_SUCCESS;
var SET_IS_CONNECTING_TO_FALSE = '@@listingModule/SET_IS_CONNECTING_TO_FALSE';
exports.SET_IS_CONNECTING_TO_FALSE = SET_IS_CONNECTING_TO_FALSE;
var UPDATE_CONNECTION_PENDING = '@@lisingModule/UPDATE_CONNECTION_PENDING';
exports.UPDATE_CONNECTION_PENDING = UPDATE_CONNECTION_PENDING;
var TOGGLE_NEED_AN_ACCOUNT_CLICKED = '@@listingModule/TOGGLE_NEED_AN_ACCOUNT_CLICKED';
exports.TOGGLE_NEED_AN_ACCOUNT_CLICKED = TOGGLE_NEED_AN_ACCOUNT_CLICKED;
var POPUP_IS_OPEN = '@@lisingModule/POPUP_IS_OPEN';
exports.POPUP_IS_OPEN = POPUP_IS_OPEN;
var POPUP_IS_CLOSED = '@@lisingModule/POPUP_IS_CLOSED'; // Modal Names

exports.POPUP_IS_CLOSED = POPUP_IS_CLOSED;
var ENROLL_MODAL = '@@listingModule/ENROLL_MODAL';
exports.ENROLL_MODAL = ENROLL_MODAL;
var UNENROLL_MODAL = '@@listingModule/UNENROLL_MODAL';
exports.UNENROLL_MODAL = UNENROLL_MODAL;
var DISCONNECT_MODAL = '@@listingModule/DISCONNECT_MODAL';
exports.DISCONNECT_MODAL = DISCONNECT_MODAL;
var CONFIRMATION_MODAL = '@@listingModule/CONFIRMATION_MODAL'; // Helper

exports.CONFIRMATION_MODAL = CONFIRMATION_MODAL;

var fetchListItems = function fetchListItems(lang, item) {
  var endpoint, options, response, json;
  return regeneratorRuntime.async(function fetchListItems$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          endpoint = "".concat(APIEndpoint, "listitems/").concat(item, "?lang=").concat(lang);
          options = {
            method: 'GET',
            headers: {}
          };
          _context.next = 4;
          return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

        case 4:
          response = _context.sent;
          _context.next = 7;
          return regeneratorRuntime.awrap(response.json());

        case 7:
          json = _context.sent;
          return _context.abrupt("return", json);

        case 9:
        case "end":
          return _context.stop();
      }
    }
  });
}; // Actions


exports.fetchListItems = fetchListItems;

var setListings = function setListings(listings) {
  var mergedListings = {};
  listings.forEach(function (listing) {
    var _newEntry;

    var newListing = {
      readyState: LISTING_FETCHED,
      data: _objectSpread({}, listing, {
        loyaltyNumber: ''
      })
    };
    var newEntry = (_newEntry = {}, _defineProperty(_newEntry, listing.ID, newListing), _defineProperty(_newEntry, listing.core.v1ID, newListing), _newEntry);
    (0, _merge13.default)(mergedListings, newEntry);
  });
  return {
    type: SET_LISTINGS,
    listings: mergedListings
  };
};

exports.setListings = setListings;

function fetchLocalizedRegions() {
  return function fetchLocalizedRegionsAsync(dispatch, getState) {
    var _getState, _getState$userPrefs, _getState$userPrefs$l, _getState$userPrefs$l2, lang, json;

    return regeneratorRuntime.async(function fetchLocalizedRegionsAsync$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getState = getState(), _getState$userPrefs = _getState.userPrefs;
            _getState$userPrefs = _getState$userPrefs === void 0 ? {} : _getState$userPrefs;
            _getState$userPrefs$l = _getState$userPrefs.localeData;
            _getState$userPrefs$l = _getState$userPrefs$l === void 0 ? {} : _getState$userPrefs$l;
            _getState$userPrefs$l2 = _getState$userPrefs$l.lang, lang = _getState$userPrefs$l2 === void 0 ? 'en-us' : _getState$userPrefs$l2;
            dispatch({
              type: REGIONS_FETCHING
            });
            _context2.prev = 6;
            _context2.next = 9;
            return regeneratorRuntime.awrap(fetchListItems(lang, 'regions'));

          case 9:
            json = _context2.sent;
            dispatch({
              type: REGIONS_FETCHED,
              json: json
            });
            return _context2.abrupt("return", json);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](6);
            dispatch({
              type: REGIONS_FETCH_FAILED
            });

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, null, null, [[6, 14]]);
  };
}

function fetchLocalizedCountries() {
  return function fetchLocalizedCountriesAsync(dispatch, getState) {
    var _getState2, _getState2$userPrefs, _getState2$userPrefs$, _getState2$userPrefs$2, lang, json;

    return regeneratorRuntime.async(function fetchLocalizedCountriesAsync$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState2 = getState(), _getState2$userPrefs = _getState2.userPrefs;
            _getState2$userPrefs = _getState2$userPrefs === void 0 ? {} : _getState2$userPrefs;
            _getState2$userPrefs$ = _getState2$userPrefs.localeData;
            _getState2$userPrefs$ = _getState2$userPrefs$ === void 0 ? {} : _getState2$userPrefs$;
            _getState2$userPrefs$2 = _getState2$userPrefs$.lang, lang = _getState2$userPrefs$2 === void 0 ? 'en-us' : _getState2$userPrefs$2;
            dispatch({
              type: COUNTRIES_FETCHING
            });
            _context3.prev = 6;
            _context3.next = 9;
            return regeneratorRuntime.awrap(fetchListItems(lang, 'countries'));

          case 9:
            json = _context3.sent;
            dispatch({
              type: COUNTRIES_FETCHED,
              json: json
            });
            return _context3.abrupt("return", json);

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](6);
            dispatch({
              type: COUNTRIES_FETCH_FAILED
            });

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, null, null, [[6, 14]]);
  };
}

function fetchListing(listingId) {
  return function fetchListingAsync(dispatch, getState) {
    var _getState3, _getState3$JWT, _getState3$JWT$token, token, _getState3$userPrefs, _getState3$userPrefs$, _getState3$userPrefs$2, lang, endpoint, options, response, result, action;

    return regeneratorRuntime.async(function fetchListingAsync$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(listingId === undefined)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", Promise.reject('missing listingId from function argument'));

          case 2:
            _getState3 = getState(), _getState3$JWT = _getState3.JWT;
            _getState3$JWT = _getState3$JWT === void 0 ? {} : _getState3$JWT;
            _getState3$JWT$token = _getState3$JWT.token, token = _getState3$JWT$token === void 0 ? '' : _getState3$JWT$token, _getState3$userPrefs = _getState3.userPrefs;
            _getState3$userPrefs = _getState3$userPrefs === void 0 ? {} : _getState3$userPrefs;
            _getState3$userPrefs$ = _getState3$userPrefs.localeData;
            _getState3$userPrefs$ = _getState3$userPrefs$ === void 0 ? {} : _getState3$userPrefs$;
            _getState3$userPrefs$2 = _getState3$userPrefs$.lang, lang = _getState3$userPrefs$2 === void 0 ? 'en-us' : _getState3$userPrefs$2;
            endpoint = "".concat(APIEndpoint, "listings/").concat(listingId, "?lang=").concat(lang, "&returnalways=true");
            dispatch({
              type: LISTING_FETCHING,
              listingId: listingId
            });
            options = {
              method: 'GET',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            _context4.prev = 13;
            _context4.next = 16;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

          case 16:
            response = _context4.sent;
            _context4.next = 19;
            return regeneratorRuntime.awrap(response.json());

          case 19:
            result = _context4.sent;
            action = response.status !== 404 ? {
              type: LISTING_FETCHED,
              listingId: listingId,
              result: result
            } : {
              type: LISTING_NOT_FOUND,
              listingId: listingId,
              result: result.message
            };
            dispatch(action);
            _context4.next = 27;
            break;

          case 24:
            _context4.prev = 24;
            _context4.t0 = _context4["catch"](13);
            return _context4.abrupt("return", dispatch({
              type: LISTING_FETCH_FAILED,
              listingId: listingId,
              error: _context4.t0
            }));

          case 27:
          case "end":
            return _context4.stop();
        }
      }
    }, null, null, [[13, 24]]);
  };
}

function shouldFetchListing(state, listingId) {
  if (!state.listing) throw new Error('Invalid State. Must have `.listing` field');
  var listingInState = state.listing[listingId];
  var listingData = (0, _get2.default)(listingInState, 'data', false);

  if (!listingData || listingInState.readyState === LISTING_FETCH_FAILED || listingInState.readyState === LISTING_INVALID) {
    return true;
  }

  return false;
} // fire and forget. return value doesn't matter and is a no-op if not needed


function fetchListingIfNeeded(listingId) {
  return function (dispatch, getState) {
    if (!listingId) return Promise.reject('missing listingId from function argument');

    if (shouldFetchListing(getState(), listingId)) {
      dispatch({
        type: LISTING_SHOULD_FETCH,
        value: true
      });
      return dispatch(fetchListing(listingId));
    }

    dispatch({
      type: LISTING_SHOULD_FETCH,
      value: false
    }); // keep a consistent interface (promise)

    return Promise.resolve();
  };
}

function queryBuilder(options) {
  var parameterDefinitions = {
    clientId: 'client_id',
    connectURL: 'redirect_uri'
  };
  var keysArr = (0, _keys2.default)(options);
  var nonEmptyOptionsKeys = (0, _filter2.default)(keysArr, function (key) {
    return options[key] !== '' && options[key] !== undefined;
  });
  var querystring = (0, _reduce2.default)(nonEmptyOptionsKeys, function (memo, option) {
    var paramString;

    if (parameterDefinitions[option] !== undefined) {
      paramString = "".concat(parameterDefinitions[option], "=").concat(encodeURIComponent(options[option]));
    } else {
      paramString = "".concat(option, "=").concat(encodeURIComponent(options[option]));
    }

    return memo === '' ? "?".concat(paramString) : "".concat(memo, "&").concat(paramString);
  }, '');
  return querystring;
}

function openWindowSync(redirectURL, width, height) {
  return function (dispatch) {
    // Centering popup within open parent window
    var windowLeft = window.screenLeft ? window.screenLeft : window.screenX;
    var windowTop = window.screenTop ? window.screenTop : window.screenY;
    var left = windowLeft + window.innerWidth / 2 - width / 2;
    var top = windowTop + window.innerHeight / 2 - height / 2;
    var windowFeatures = "scrollbars=1,resizable=1,width=".concat(width, ", height=").concat(height, ", top=").concat(top, ", left=").concat(left);
    var popup = window.open(redirectURL, 'Connect', windowFeatures);
    dispatch({
      type: POPUP_IS_OPEN
    });
    return popup;
  };
}

var makeXMLHttpRequest = function makeXMLHttpRequest(requestUrl, method) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    request.open(method || 'GET', requestUrl);

    request.onload = function () {
      if (request.status === 200) {
        resolve(true);
      } else {
        reject(false);
      }
    };

    request.send();
  });
};

function disconnectTripIt(csrfToken) {
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();
    request.open('POST', "".concat(_config.default.CTEUrl, "/net2/TripIt/UnlinkFromTripIt.ashx"));
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    request.onload = function () {
      if (request.status === 200) {
        resolve(true);
      } else {
        reject(false);
      }
    };

    request.send("csrf_token=".concat(csrfToken));
  });
}

var updateConnectionPending = function updateConnectionPending(listingId) {
  return {
    type: UPDATE_CONNECTION_PENDING,
    listingId: listingId
  };
};
/**
 * This function is never called on production because no listings have
 * 'CONREQFLOW' as their oAuthWorkflowType.
 */


function connectWithLoyaltyNumber(ID) {
  return function connectWithLoyaltyNumberAsync(dispatch, getState) {
    var state, _state$listing$ID$dat, loyaltyNumber, triplinkLoyaltyNumber, _state$JWT, _state$JWT$token, token, options, loyaltyNum;

    return regeneratorRuntime.async(function connectWithLoyaltyNumberAsync$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            state = getState();
            _state$listing$ID$dat = state.listing[ID].data, loyaltyNumber = _state$listing$ID$dat.loyaltyNumber, triplinkLoyaltyNumber = _state$listing$ID$dat.core.triplinkLoyaltyNumber;
            _state$JWT = state.JWT;
            _state$JWT = _state$JWT === void 0 ? {} : _state$JWT;
            _state$JWT$token = _state$JWT.token, token = _state$JWT$token === void 0 ? '' : _state$JWT$token;
            options = {
              method: 'PUT',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            loyaltyNum = !triplinkLoyaltyNumber ? loyaltyNumber : '';
            _context5.prev = 8;
            _context5.next = 11;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)("".concat(APIEndpoint, "v3/listings/").concat(ID, "/connections?loyaltyNumber=").concat(loyaltyNum), options));

          case 11:
            dispatch(updateConnectionPending(ID));
            _context5.next = 17;
            break;

          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](8);
            console.error(_context5.t0);

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, null, null, [[8, 14]]);
  };
}

function connectWithLoyaltyNumberLegacy(ID) {
  return function (dispatch, getState) {
    var _getState$listing$ID$ = getState().listing[ID].data,
        loyaltyNumber = _getState$listing$ID$.loyaltyNumber,
        _getState$listing$ID$2 = _getState$listing$ID$.core,
        triplinkSupplierID = _getState$listing$ID$2.triplinkSupplierID,
        triplinkLoyaltyNumber = _getState$listing$ID$2.triplinkLoyaltyNumber;
    var addLoyaltyUrl = "".concat(_config.default.CTEUrl, "/UI/appcenter/AddLoyaltyNumber?supplierId=").concat(triplinkSupplierID, "&loyaltyNumber=").concat(loyaltyNumber);
    var autoConnectUrl = "".concat(_config.default.CTEUrl, "/UI/appcenter/AutoConnectToSupplier?supplierId=").concat(triplinkSupplierID);
    var options = {
      method: 'GET',
      headers: {}
    };

    if (!triplinkLoyaltyNumber) {
      makeXMLHttpRequest(addLoyaltyUrl).then(function () {
        makeXMLHttpRequest(autoConnectUrl);
      }).then(function () {
        dispatch(updateConnectionPending(ID));
      });
    } else {
      makeXMLHttpRequest(autoConnectUrl).then(function () {
        dispatch(updateConnectionPending(ID));
      });
    }
  };
}

function toggleNeedAnAccountClicked(wasClicked) {
  return function (dispatch) {
    return dispatch({
      type: TOGGLE_NEED_AN_ACCOUNT_CLICKED,
      wasClicked: wasClicked
    });
  };
}

var connectionStatusChecking = function connectionStatusChecking() {
  return {
    type: CONNECTION_STATUS_CHECKING
  };
};

function checkForConnection(listingId, v1ListingId, popupWindow) {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        _getState4$JWT = _getState4.JWT;

    _getState4$JWT = _getState4$JWT === void 0 ? {} : _getState4$JWT;
    var _getState4$JWT$token = _getState4$JWT.token,
        token = _getState4$JWT$token === void 0 ? '' : _getState4$JWT$token,
        _getState4$userPrefs$ = _getState4.userPrefs.localeData.lang,
        lang = _getState4$userPrefs$ === void 0 ? 'en-us' : _getState4$userPrefs$;
    var ID = (0, _has2.default)(getState(), "listing[".concat(listingId, "].data.core")) ? listingId : v1ListingId;
    dispatch(connectionStatusChecking());
    var popupClosedCounter = 0;
    var intervalID = window.setInterval(function _callee() {
      var options, endpoint, response, json;
      return regeneratorRuntime.async(function _callee$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (popupWindow && popupWindow.closed && popupClosedCounter < 3) {
                popupClosedCounter += 1;

                if (popupClosedCounter === 2) {
                  dispatch({
                    type: SET_IS_CONNECTING_TO_FALSE
                  });
                  dispatch(toggleNeedAnAccountClicked(false));
                  window.clearInterval(intervalID);
                }
              }

              options = {
                method: 'GET',
                headers: {}
              };
              if (token) options.headers.Authorization = "Bearer ".concat(token);
              endpoint = "".concat(APIEndpoint, "listings/").concat(ID, "?lang=").concat(lang, "&returnalways=true");
              _context6.prev = 4;
              _context6.next = 7;
              return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(endpoint, options));

            case 7:
              response = _context6.sent;
              _context6.next = 10;
              return regeneratorRuntime.awrap(response.json());

            case 10:
              json = _context6.sent;

              if (json.core.isUserConnected) {
                dispatch({
                  type: CONNECTION_STATUS_CHECKED_SUCCESS,
                  ID: ID
                });
                dispatch((0, _listingsModule.updateConnectedStatus)(ID, true));
                window.clearInterval(intervalID);
              }

              _context6.next = 17;
              break;

            case 14:
              _context6.prev = 14;
              _context6.t0 = _context6["catch"](4);
              dispatch({
                type: LISTING_FETCH_FAILED,
                ID: ID,
                error: _context6.t0
              });

            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, null, null, [[4, 14]]);
    }, 2000);
  };
}

var getKeyAndID = function getKeyAndID(listingId, v1ListingId, state) {
  var consumerKeyOrAppId;
  var ID;

  if ((0, _has2.default)(state, "listing[".concat(listingId, "].data.core"))) {
    ID = listingId;
    consumerKeyOrAppId = state.listing[ID].data.core.partnerAppConsumerKey !== '' ? state.listing[ID].data.core.partnerAppConsumerKey : state.listing[ID].data.core.partnerAppId;
  } else {
    ID = v1ListingId;
    consumerKeyOrAppId = state.listing[ID].data.core.partnerAppConsumerKey !== '' ? state.listing[ID].data.core.partnerAppConsumerKey : state.listing[ID].data.core.partnerAppId;
  }

  return {
    consumerKeyOrAppId: consumerKeyOrAppId,
    ID: ID
  };
};

function connectListing(listingId, v1ListingId) {
  return function connectListingAsync(dispatch, getState) {
    var state, ID, _state$listing$ID$dat2, loyaltyNumber, _state$listing$ID$dat3, oAuthWorkflowType, triplinkSupplierID, triplinkLoyaltyNumber, _state$JWT2, _state$JWT2$token, token, _state$listing, needAnAccountClicked, isConnecting, options, popupWindow, response, json;

    return regeneratorRuntime.async(function connectListingAsync$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            state = getState();
            ID = (0, _has2.default)(state, "listing[".concat(listingId, "].data.core")) ? listingId : v1ListingId;
            _state$listing$ID$dat2 = state.listing[ID].data, loyaltyNumber = _state$listing$ID$dat2.loyaltyNumber, _state$listing$ID$dat3 = _state$listing$ID$dat2.core, oAuthWorkflowType = _state$listing$ID$dat3.oAuthWorkflowType, triplinkSupplierID = _state$listing$ID$dat3.triplinkSupplierID, triplinkLoyaltyNumber = _state$listing$ID$dat3.triplinkLoyaltyNumber;
            _state$JWT2 = state.JWT;
            _state$JWT2 = _state$JWT2 === void 0 ? {} : _state$JWT2;
            _state$JWT2$token = _state$JWT2.token, token = _state$JWT2$token === void 0 ? '' : _state$JWT2$token, _state$listing = state.listing, needAnAccountClicked = _state$listing.needAnAccountClicked, isConnecting = _state$listing.isConnecting;

            if (!isConnecting) {
              dispatch(connectionStatusChecking());
            }

            dispatch({
              type: CONNECT_LISTING
            });

            if (!(oAuthWorkflowType === 'AUTOCONFLOW' && !needAnAccountClicked)) {
              _context7.next = 12;
              break;
            }

            dispatch(connectWithLoyaltyNumberLegacy(ID));
            _context7.next = 34;
            break;

          case 12:
            if (!(oAuthWorkflowType === 'CONREQFLOW')) {
              _context7.next = 16;
              break;
            }

            /**
             * This branch is never executed on production because no listings have
             * 'CONREQFLOW' as their oAuthWorkflowType.
             */
            dispatch(connectWithLoyaltyNumber(ID));
            _context7.next = 34;
            break;

          case 16:
            options = {
              method: 'PUT',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            popupWindow = dispatch(openWindowSync('', 800, 650)); // after putting this in async/await, it throws a chrome security error
            // popupWindow.document.write('Calculating Inverse Probability Matrices...');

            _context7.prev = 19;
            _context7.next = 22;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)("".concat(APIEndpoint, "v3/listings/").concat(ID, "/connections"), options));

          case 22:
            response = _context7.sent;
            _context7.next = 25;
            return regeneratorRuntime.awrap(response.json());

          case 25:
            json = _context7.sent;
            popupWindow.location.href = oAuthWorkflowType === 'APPCNTRFLOW' ? "https://".concat(window.location.hostname).concat(json.redirectUrl) : json.redirectUrl;
            dispatch(checkForConnection(listingId, v1ListingId, popupWindow));
            _context7.next = 34;
            break;

          case 30:
            _context7.prev = 30;
            _context7.t0 = _context7["catch"](19);
            popupWindow.close();
            console.error(_context7.t0);

          case 34:
          case "end":
            return _context7.stop();
        }
      }
    }, null, null, [[19, 30]]);
  };
}

var toggleModal = function toggleModal(modalName) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: TOGGLE_MODAL,
    modalName: modalName,
    options: options
  };
};

exports.toggleModal = toggleModal;

var disconnectFromListing = function disconnectFromListing(listingId) {
  return {
    type: DISCONNECT_LISTING,
    listingId: listingId
  };
};

exports.disconnectFromListing = disconnectFromListing;

function disconnectListing(listingId, v1ListingId) {
  return function disconnectListingAsync(dispatch, getState) {
    var state, _state$JWT3, _state$JWT3$token, token, _getKeyAndID, ID, confirmOrDeny, connectURL, _state$listing$ID$dat4, listingType, oAuthWorkflowType, success, endpoint, _success, options, disconnectEndpoint, response;

    return regeneratorRuntime.async(function disconnectListingAsync$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            state = getState();
            _state$JWT3 = state.JWT;
            _state$JWT3 = _state$JWT3 === void 0 ? {} : _state$JWT3;
            _state$JWT3$token = _state$JWT3.token, token = _state$JWT3$token === void 0 ? '' : _state$JWT3$token;
            _getKeyAndID = getKeyAndID(listingId, v1ListingId, state), ID = _getKeyAndID.ID;

            confirmOrDeny = function confirmOrDeny(wasSuccess, listingType) {
              if (wasSuccess) {
                dispatch(disconnectFromListing(ID));
                dispatch((0, _listingsModule.updateConnectedStatus)(ID, false));
                dispatch(toggleModal(CONFIRMATION_MODAL, {
                  disconnectSuccess: true,
                  listingType: listingType
                }));
              } else {
                dispatch(toggleModal(CONFIRMATION_MODAL, {
                  disconnectSuccess: false,
                  listingType: listingType
                }));
              }
            };

            connectURL = state.listing[ID].data.localized.connectURL || '';
            _state$listing$ID$dat4 = state.listing[ID].data.core, listingType = _state$listing$ID$dat4.listingType, oAuthWorkflowType = _state$listing$ID$dat4.oAuthWorkflowType;

            if (!(connectURL.indexOf('/signup_tripit.asp') !== -1)) {
              _context8.next = 15;
              break;
            }

            _context8.next = 11;
            return regeneratorRuntime.awrap(disconnectTripIt(state.userPrefs.csrf_token));

          case 11:
            success = _context8.sent;
            confirmOrDeny(success, listingType);
            _context8.next = 38;
            break;

          case 15:
            if (!(listingType === 'ACONCT')) {
              _context8.next = 23;
              break;
            }

            endpoint = "".concat(_config.default.CTEUrl, "/ui/appcenter/ChangeAutoConnectPreference?enroll=false&_=").concat(new Date().getTime());
            _context8.next = 19;
            return regeneratorRuntime.awrap(makeXMLHttpRequest(endpoint));

          case 19:
            _success = _context8.sent;
            confirmOrDeny(_success, listingType);
            _context8.next = 38;
            break;

          case 23:
            options = {
              method: 'DELETE',
              headers: {}
            };
            if (token) options.headers.Authorization = "Bearer ".concat(token);
            disconnectEndpoint = listingType === 'AUTOCONFLOW' ? "".concat(APIEndpoint, "connections/").concat(ID) : "".concat(APIEndpoint, "v3/listings/").concat(ID, "/connections");
            _context8.prev = 26;
            _context8.next = 29;
            return regeneratorRuntime.awrap((0, _isomorphicFetch.default)(disconnectEndpoint, options));

          case 29:
            response = _context8.sent;
            confirmOrDeny(response.ok);

            if (response.ok) {
              _context8.next = 33;
              break;
            }

            throw response;

          case 33:
            _context8.next = 38;
            break;

          case 35:
            _context8.prev = 35;
            _context8.t0 = _context8["catch"](26);
            console.error(_context8.t0);

          case 38:
          case "end":
            return _context8.stop();
        }
      }
    }, null, null, [[26, 35]]);
  };
}

function updateLoyaltyNum(listingId, loyaltyNum) {
  return {
    type: UPDATE_LOYALTY_NUM,
    listingId: listingId,
    loyaltyNum: loyaltyNum
  };
}

function inquireListing() {
  return {
    type: INQUIRE_LISTING
  };
} // Reducer


var initialState = {
  isEnrollModalOpen: false,
  isDisconnectModalOpen: false,
  isConfirmationModalOpen: false,
  isUnenrollModalOpen: false,
  isConnecting: false,
  isPopupOpen: false,
  needAnAccountClicked: false,
  modalOptions: {},
  modalNames: {
    enroll: ENROLL_MODAL,
    unenroll: UNENROLL_MODAL,
    disconnect: DISCONNECT_MODAL,
    confirmation: CONFIRMATION_MODAL
  }
}; // TODO: what is this for?

exports.initialState = initialState;

function listing() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'dev/CHANGE_FIELD':
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        data: action.object
      }));

    case LISTING_FETCHING:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_FETCHING
      }));

    case LISTING_INVALID:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_INVALID
      }));

    case LISTING_FETCH_FAILED:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_FETCH_FAILED,
        error: action.error
      }));

    case LISTING_FETCHED:
      return (0, _merge13.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.listingId, {
        readyState: LISTING_FETCHED,
        data: _objectSpread({}, action.result, {
          loyaltyNumber: ''
        })
      }));

    case SET_LISTINGS:
      return (0, _merge13.default)({}, state, action.listings);

    case LISTING_NOT_FOUND:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        readyState: LISTING_NOT_FOUND,
        data: action.result
      }));

    case CONNECT_LISTING:
      return state;

    case DISCONNECT_LISTING:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        data: {
          core: {
            isUserConnected: false
          }
        }
      }));

    case CONNECTION_STATUS_CHECKING:
      return (0, _merge13.default)({}, state, {
        isConnecting: true
      });

    case SET_IS_CONNECTING_TO_FALSE:
      return (0, _merge13.default)({}, state, {
        isConnecting: false
      });

    case CONNECTION_STATUS_CHECKED_SUCCESS:
      return (0, _merge13.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.ID, {
        data: {
          core: {
            isUserConnected: true
          }
        }
      }));

    case UPDATE_CONNECTION_PENDING:
      return (0, _merge13.default)({}, state, _defineProperty({
        isConnecting: false
      }, action.listingId, {
        data: {
          core: {
            isConnectionPending: true
          }
        }
      }));

    case REGIONS_FETCHED:
      return (0, _merge13.default)({}, state, {
        localizedRegions: action.json
      });

    case COUNTRIES_FETCHED:
      return (0, _merge13.default)({}, state, {
        localizedCountries: action.json
      });

    case TOGGLE_MODAL:
      {
        var _merge11;

        var modalKey;

        switch (action.modalName) {
          case ENROLL_MODAL:
            modalKey = 'isEnrollModalOpen';
            break;

          case UNENROLL_MODAL:
            modalKey = 'isUnenrollModalOpen';
            break;

          case DISCONNECT_MODAL:
            modalKey = 'isDisconnectModalOpen';
            break;

          case CONFIRMATION_MODAL:
            modalKey = 'isConfirmationModalOpen';
            break;

          default:
            console.error('toggle requires a modal constant found in listingModule.js');
            break;
        }

        return (0, _merge13.default)({}, state, (_merge11 = {}, _defineProperty(_merge11, modalKey, !state[modalKey]), _defineProperty(_merge11, "modalOptions", _objectSpread({}, state.modalOptions, {}, action.options)), _merge11));
      }

    case UPDATE_LOYALTY_NUM:
      return (0, _merge13.default)({}, state, _defineProperty({}, action.listingId, {
        data: {
          loyaltyNumber: action.loyaltyNum
        }
      }));

    case TOGGLE_NEED_AN_ACCOUNT_CLICKED:
      return (0, _merge13.default)({}, state, {
        needAnAccountClicked: action.wasClicked
      });

    case POPUP_IS_OPEN:
      return (0, _merge13.default)({}, state, {
        isPopupOpen: true
      });

    case POPUP_IS_CLOSED:
      return (0, _merge13.default)({}, state, {
        isPopupOpen: false
      });

    default:
      return state;
  }
}


//////////////////
// WEBPACK FOOTER
// ./lib/listing/listingModule.js
// module id = 6
// module chunks = 0